"use client";

import * as React from "react";
import Link from "next/link";

import { Container } from "@/app/_components/layout/container";
import { Section } from "@/app/_components/layout/section";
import { Button } from "@/components/ui/button";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  React.useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <Section tone="default" spacing="xl" ariaLabel="Fehler">
      <Container size="narrow">
        <div className="rounded-card border border-clarus-rose bg-clarus-rose/30 p-10 text-center md:p-16">
          <h1 className="text-display-lg text-clarus-dark">
            Da ist leider etwas schiefgelaufen.
          </h1>
          <p className="text-subline mt-4 text-clarus-dark/80">
            Wir konnten die Seite nicht laden. Bitte versuchen Sie es erneut.
          </p>
          {error.digest ? (
            <p className="text-annotation mt-4 text-clarus-dark/50">
              Referenz: {error.digest}
            </p>
          ) : null}
          <div className="mt-8 flex flex-wrap justify-center gap-3">
            <Button type="button" size="lg" variant="primary" onClick={reset}>
              Erneut versuchen
            </Button>
            <Button asChild size="lg" variant="outline">
              <Link href="/">Zur Startseite</Link>
            </Button>
          </div>
        </div>
      </Container>
    </Section>
  );
}
